import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useConfiguration } from '../../../../context/configurationContext';
import SectionContainer from '../SectionContainer';
import ListingCard from '../../../../components/ListingCard/ListingCard';
import { fetchListingsByCategory } from './SectionSliderOwn.duck';
import css from './SectionSliderOwn.module.css';

import { FormattedMessage, useIntl } from '../../../../util/reactIntl'

const SectionSliderOwn = (props) => {

    //console.log("👀", categoryId);

    const intl = useIntl();

    const { categoryId = null,
            title,
            description, } = props;

    const history = useHistory();
    const dispatch = useDispatch();
    const config = useConfiguration();
    
    const [ shortListings, setShortListings ] = useState([]);
    // Obtener datos del store
    const listings = useSelector(state => state.SectionSliderOwn.listingsByCategory[categoryId] || []);
    //const listings = useSelector(state => state.sectionSlider?.listingsByCategory?.[categoryId] || []);
    const loading = useSelector(state => state.sectionSlider?.loading?.[categoryId] || false);
    const error = useSelector(state => state.sectionSlider?.error?.[categoryId] || null);
//console.log("test categoryId", categoryId, test)
    // Buscar listings al montar el componente
    useEffect(() => {
        if (categoryId && !listings.length && !loading) {
            dispatch(fetchListingsByCategory(config, categoryId, 100));
        }
    }, [dispatch, categoryId, listings.length, loading]);

    if (loading) {
        return (
            <SectionContainer>
                <h2>Productos Destacados</h2>
                <p>Cargando productos...</p>
            </SectionContainer>
        );
    }

    if (error) {
        return (
            <SectionContainer>
                <h2>Productos Destacados</h2>
                <p>Error al cargar productos</p>
            </SectionContainer>
        );
    }

    //console.log("👽", config.categoryConfiguration.categories)
    useEffect(() => {
      setShortListings(listings.slice(0, 2)); 
      return () => {}
    }, [listings.length])
    

    return (
        <SectionContainer
            className={css.sectionSliderOwn}
            title="Productos Destacados"
            subtitle="Descubre nuestros productos destacados"
        >
            <div className={css.contentProducts}>
                { title?.content && <h4>{title.content}</h4> }
                { description?.content && <p className={css.description}>{description.content}</p> }
                
                {/* <p>This is a custom slider section for products highlighted.</p> */}

                <span className={css.longListings}>
                    {listings.length > 0 ? (
                        <div className={css.listingCards}>
                        {listings.map(listing => (
                            <ListingCard
                                listing={listing}
                                config={config}
                                //renderSizes="(max-width: 767px) 100vw, 33vw"
                            />
                        ))}
                        </div>
                    ) : (
                        <p>No hay productos disponibles en esta categoría</p>
                    )}
                </span>

                <span className={css.shortListings}>
                    {shortListings.length > 0 ? (
                        <div className={css.listingCards}>
                        {shortListings.map(listing => (
                            <ListingCard
                                listing={listing}
                                config={config}
                                //renderSizes="(max-width: 767px) 100vw, 33vw"
                            />
                        ))}
                        </div>
                    ) : (
                        <p>No hay productos disponibles en esta categoría</p>
                    )}
                </span>

                <div 
                    onClick={() => {
                        history.push(`/s?category=${categoryId}&pub_categoryLevel1=${categoryId}`);
                    }}
                    className={css.btViewmore}>› {intl.formatMessage({ id: 'SectionSlider.btViewMore' })} <span className={css.btViewmoreCategory}>{title.content}</span>
                </div>
            </div>
        </SectionContainer>
    );
};

export default SectionSliderOwn;